import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";
import { AuthShell, AuthField, SubmitButton } from "@/components/AuthShell";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const to = location.state?.from || "/dashboard";

  if (user) return <Navigate to={to} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await login(form.email, form.password); navigate(to, { replace: true }); }
    catch (err) { setError(errorMessage(err, "Invalid email or password")); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Welcome back" sub="Log in to see your new project requests."
      footer={<>New to Squadrum? <Link to="/register" className="font-semibold text-slate-900 underline" data-testid="login-register-link">Start your 14-day free trial</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <AuthField label="Email" type="email" autoComplete="email" required value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" />
        <AuthField label="Password" type="password" autoComplete="current-password" required value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" />
        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
        <SubmitButton loading={loading} testId="login-submit-button">Log in</SubmitButton>
        <Link to="/forgot-password" className="block py-2 text-center text-sm font-semibold text-slate-600 underline" data-testid="login-forgot-password-link">
          Forgot password?
        </Link>
      </form>
    </AuthShell>
  );
}
